import RoutesTitreDetention from './titre-detention/routes';

import RoutesCeaf from './ceaf/routes';
import { initSubRoutes } from '../../../utils/router';

const RoutesMesDemarches = initSubRoutes({
    route: '/mes-demarches',
    subroutes: {
        ceaf: RoutesCeaf,
        titreDetetion: RoutesTitreDetention,
    },
    nom: 'Mes démarches',
});

export default RoutesMesDemarches;
